import React from 'react'
import { Outlet } from 'react-router-dom'
import { useCustomRates } from './useCustomRates'
import { useTxNotifications } from './useTxNotifications'
import { useKycNotifications } from './useKycNotifications'
import { usePreviousPage } from './usePreviousPage'
import { useHistoryUpdate } from './useHistoryUpdate'
import { useChallenges } from './useChallenges'
import useRequestAuth from '~hooks/useRequestAuth'
import Layout from '~components/App/Layout'
import { useWalletBalances } from '~api'

function Main() {
    useRequestAuth()
    useCustomRates()
    useTxNotifications()
    useKycNotifications()
    usePreviousPage()
    useHistoryUpdate()
    useWalletBalances()
    useChallenges()

    return (
        <Layout>
            <Outlet />
        </Layout>
    )
}

export default Main
